"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ImportStatus: function() {
        return ImportStatus;
    },
    ImportVariant: function() {
        return ImportVariant;
    },
    ImportContacts: function() {
        return ImportContacts;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _loadingBar = require("../LoadingBar");
var _button = require("../Button");
var _icon = require("../Icon");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ImportStatus;
(function(ImportStatus) {
    ImportStatus["NOT_STARTED"] = "";
    ImportStatus["UPLOADING"] = "UPLOADING";
    ImportStatus["UPLOADED"] = "UPLOADED";
    ImportStatus["PROCESSING"] = "PROCESSING";
    ImportStatus["PROCESSED"] = "PROCESSED";
    ImportStatus["ERROR_PROCESSING"] = "ERROR_PROCESSING";
    ImportStatus["IMPORTING"] = "IMPORTING";
    ImportStatus["IMPORTED"] = "IMPORTED";
    ImportStatus["ERROR_IMPORTING"] = "ERROR_IMPORTING";
    ImportStatus["CANCELLED"] = "CANCELLED";
})(ImportStatus || (ImportStatus = {}));
var ImportVariant;
(function(ImportVariant) {
    ImportVariant["SUBSCRIBERS"] = "subscribers";
    ImportVariant["STEPPER"] = "stepper";
})(ImportVariant || (ImportVariant = {}));
var ImportContacts = function(_param) {
    var status = _param.status, availableContacts = _param.availableContacts, fileName = _param.fileName, message = _param.message, learnUrl = _param.learnUrl, onImport = _param.onImport, skippedContacts = _param.skippedContacts, onCancel = _param.onCancel, onDismiss = _param.onDismiss, _param_variant = _param.variant, variant = _param_variant === void 0 ? ImportVariant.SUBSCRIBERS : _param_variant, other = _objectWithoutProperties(_param, [
        "status",
        "availableContacts",
        "fileName",
        "message",
        "learnUrl",
        "onImport",
        "skippedContacts",
        "onCancel",
        "onDismiss",
        "variant"
    ]);
    // FIXME: The upload step is not handled nicely right now, the upload can finish while users do something else and then the
    // mutation to trigger the processing won't happen.
    // Let's say I'm on stepper and I upload a very big file, hit skip to next while it process. Finish onboarding and
    // while I'm writing my post, loading another page, etc, while the upload finishes on the backend. Then It can happen
    // that mutation that trigger the processing won't be called and the file will be stucked on UPLOADED STATE
    //We need a button to trigger the process when that happens
    // Dez: the api should already have support to fix the above!
    var onProgress = [
        "IMPORTING",
        "PROCESSING",
        "UPLOADING",
        "UPLOADED"
    ].includes(status) || !status;
    var hasSucceed = [
        "PROCESSED",
        "IMPORTED"
    ].includes(status);
    var isDone = [
        "IMPORTED",
        "CANCELLED"
    ].includes(status);
    var hasFailed = [
        "ERROR_PROCESSING",
        "ERROR_IMPORTING"
    ].includes(status);
    var totalContacts = (skippedContacts || 0) + (availableContacts || 0);
    var canImport = availableContacts > 0 && variant !== ImportVariant.STEPPER && status === ImportStatus.PROCESSED;
    var title = /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, status === ImportStatus.IMPORTING ? "Importing contacts" : "Processing ".concat(fileName || "file"), "...");
    if (status === ImportStatus.PROCESSED || status === ImportStatus.ERROR_IMPORTING) {
        title = /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, "We found ", /*#__PURE__*/ _react.default.createElement("span", {
            className: "text-sm text-gray-900 font-bold"
        }, totalContacts || 0), " ", "contact(s) in ", fileName || "file");
    } else if (isDone) {
        title = /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, "Added ", availableContacts, " contacts");
    }
    var classes = {
        root: (0, _classnames.default)("flex flex-col", variant === ImportVariant.SUBSCRIBERS && "rounded-lg shadow p-6", variant === ImportVariant.STEPPER && "w-full"),
        body: (0, _classnames.default)("flex flex-row items-center rounded-md p-8", hasFailed ? "bg-red-50" : "bg-gray-50", variant === ImportVariant.SUBSCRIBERS && "flex-row justify-between", variant === ImportVariant.STEPPER && "flex-col justify-center w-full h-72"),
        info: (0, _classnames.default)("flex items-center", variant === ImportVariant.SUBSCRIBERS && "flex-row", variant === ImportVariant.STEPPER && "flex-col justify-center w-full"),
        main: (0, _classnames.default)("flex flex-col justify-center", variant === ImportVariant.STEPPER && "items-center"),
        loading: (0, _classnames.default)(variant === ImportVariant.SUBSCRIBERS && "mr-6", variant === ImportVariant.STEPPER && "mb-2 pb-2"),
        actions: (0, _classnames.default)("flex items-center", variant === ImportVariant.SUBSCRIBERS && "flex-row", variant === ImportVariant.STEPPER && onProgress && "hidden", variant === ImportVariant.STEPPER && "justify-center mt-4")
    };
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.root,
        "data-testid": other["data-testid"]
    }, variant === ImportVariant.SUBSCRIBERS && /*#__PURE__*/ _react.default.createElement("span", {
        className: "text-lg text-gray-900 mb-5 font-medium"
    }, "Import Contacts"), /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.body
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.info
    }, onProgress && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.loading
    }, /*#__PURE__*/ _react.default.createElement(_loadingBar.LoadingBar, {
        size: "md"
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.main
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: "text-sm text-gray-900 font-medium"
    }, title))), !onProgress && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.loading
    }, hasSucceed && /*#__PURE__*/ _react.default.createElement(_icon.CheckCircle, null), hasFailed && /*#__PURE__*/ _react.default.createElement(_icon.InfoCircle, null)), /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.main
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: "text-sm text-gray-900 font-medium"
    }, title), (status === ImportStatus.PROCESSED || status === ImportStatus.ERROR_IMPORTING) && /*#__PURE__*/ _react.default.createElement("span", {
        className: "text-sm text-gray-500 mt-1"
    }, message || "".concat(availableContacts || 0, " contact(s) can be added \xb7 ").concat(skippedContacts || 0, " will be skipped"), " ", skippedContacts ? /*#__PURE__*/ _react.default.createElement("a", {
        href: learnUrl || "#",
        className: "text-accent-600 font-medium hover:text-accent-700"
    }, "Learn why") : null)))), /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.actions
    }, /*#__PURE__*/ _react.default.createElement(_button.ButtonDefault, {
        onClick: function(e) {
            return isDone ? onDismiss(e) : onCancel(e);
        }
    }, isDone ? "Dismiss" : "Cancel"), canImport && !onProgress && !isDone && /*#__PURE__*/ _react.default.createElement(_button.ButtonSecondary, {
        className: "ml-3",
        onClick: onImport
    }, "Import ", availableContacts || 0, " contact(s)"))));
};

//# sourceMappingURL=ImportContacts.js.map